import { render, staticRenderFns } from "./AssistantUserPanel.vue?vue&type=template&id=2202581a&scoped=true"
import script from "./AssistantUserPanel.vue?vue&type=script&lang=js"
export * from "./AssistantUserPanel.vue?vue&type=script&lang=js"
import style0 from "./AssistantUserPanel.vue?vue&type=style&index=0&id=2202581a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2202581a",
  null
  
)

export default component.exports